import React from 'react';
import BeddingConfigEdit from '../../../profile/edit-modal/bedding-config/bedding-config';
import { FlatButton } from 'material-ui';

const UpdateBeddingConfig = props => {
  const {
    data: { bedsAndSofas },
    productId,
    onRequestClose,
    onTextFieldChangeWithKeyPath,
    editProductProfile,
    locationId,
    contractId,
  } = props;
  const onSave = () => editProductProfile({ contractId, productId, updateBody: bedsAndSofas, updateField: 'bedsAndSofas', locationId });
  const sendEditToReducer = ({ value, isBeddingConfigInvalid }) => onTextFieldChangeWithKeyPath({
    keyPath: ['data'],
    value: {
      ...props.data,
      bedsAndSofas: value,
      isBeddingConfigInvalid,
    },
  });
  return (
    <div>
      <BeddingConfigEdit
        beddingConfig={bedsAndSofas}
        sendEditToReducer={sendEditToReducer}
      />
      <div style={{ display: 'flex', flexDirection: 'row-reverse' }}>
        <div className="flex-center">
          <FlatButton
            label="Cancel"
            primary
            onClick={onRequestClose}
          />
          <FlatButton
            label="Save"
            secondary
            onClick={onSave}
          />
        </div>
      </div>
    </div>
  );
};

export default UpdateBeddingConfig;



// WEBPACK FOOTER //
// ./src/app/components/contracting/contract-activities-products/add-edit-dialog-content/update-bedding-config.jsx